import profilePic from "assets/images/png/avatar.png";

export const chatData = {
  isAccepted: true,
  name: "Annie Jay",
  status: "Online",
  profilePic,
  accountId: "AEC0003123",
  lastSeen: "Last seen: 10 min ago",
  alert: "Accept message request from Annie Jay?",
  info: "If you accept, they will be able to call you and see all your information.",
};

export const chatHeaderMenuItems = [
  { key: "mute", label: "Mute chat" },
  { key: "pin", label: "Pin the chat" },
  { key: "clear", label: "Clear chat" },
  { key: "favorite", label: "Favorite chat" },
  { key: "block", label: "Block the profile" },
  { key: "report", label: "Report the profile" },
];

export const suggestionMessages = ["Great", "Thank you", "How’s your day?"];
